module.exports = __webpack_public_path__ + "static/7-d5e8fb4f7c0066bba6a3163264b6f1b6.jpeg";